import React from 'react'
import { Route, IndexRedirect, IndexRoute, Redirect } from 'react-router'


import LoginComponent from 'components/LoginComponent'
import LoginContainer from 'containers/LoginContainer'
import App from 'containers/App'
import Dashboard from 'components/dashboard/Dashboard'
import MybetsContainer from 'containers/MybetsContainer'
import EdgebetContainer from 'containers/EdgebetContainer'
import ProfileContainer from 'containers/ProfileContainer'
import GetStartedContainer from 'containers/GetStartedContainer'
import NotFoundView from 'containers/NotFoundView'
import AnalyticsContainer from 'containers/AnalyticsContainer'
import ForumContainer  from 'containers/ForumContainer'
import ForumList from 'components/forum/ForumList'
import ForumComponent from 'components/forum/ForumComponent'
import Thread from 'components/forum/Thread'
// import SubscribeComponent from 'components/SubscribeComponent'
// import PurchaseComponent from 'components/PurchaseComponent'
import AdminPanel from 'components/admin/AdminPanel'
import TrialEnded from 'components/TrialEnded'
import FeatureBoardContainer from 'containers/FeatureBoardContainer'

export default () => [(
  <Route path='/user' component={LoginContainer} key='user-admin'>
    <Route path='/login' component={LoginComponent} />
  </Route>),
  (<Route path='/' component={App} key='app'>
    <Route path='/dashboard' component={Dashboard}/>
    <IndexRedirect to='/dashboard' />
    <Route path='/trial-ended' component={TrialEnded} />
    <Route path='/mybets' component={MybetsContainer} />
    <Route path='/edgebets' component={EdgebetContainer} />
    <Route path='/get-started' component={GetStartedContainer} />
    <Route path='/me' component={ProfileContainer} />
    <Route path='/404' component={NotFoundView} />
    <Route path='/analytics' component={AnalyticsContainer} />
    <Route path='/admin' component={AdminPanel} />
    <Route path='/featureboard' component={FeatureBoardContainer} />
    <Route path="/forum" component={ForumContainer}>
      <IndexRoute component={ForumList} />
      <Route path=":forumTitle" component={ForumComponent} />
      <Route path="/forum/:name/:threadName" component={Thread} />
    </Route>
    <Route path="/404" component={NotFoundView} />
    <Redirect from='*' to='/404' />
  </Route>
)]



/** WEBPACK FOOTER **
 ** ./src/routes/index.js
 **/